import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { organisationsQueryOptions } from '@/api/resources/organisations'
import { CompanyWalletIntro } from '@/components/company-wallet/company-wallet-intro'
import { CompanyWalletOrganisationCard } from '@/components/company-wallet/company-wallet-organisation-card'
import { LoadingSpinner } from '@/components/feedback/loading-spinner'
import { PageHeader } from '@/components/layout/page-header'

export const Route = createFileRoute('/_app/wallets/')({
  head: () => ({ meta: [{ title: 'Wallets - MyJunea' }] }),
  component: CompanyWalletIndexPage,
})

function CompanyWalletIndexPage(): React.ReactElement {
  const { data, isLoading } = useQuery(organisationsQueryOptions())

  const organisations = data?.filter((organisation) => organisation.company_wallet_enabled)

  return (
    <div className="space-y-6">
      <PageHeader title="Wallets" description={<CompanyWalletIntro />} />

      {isLoading && <LoadingSpinner />}

      {!isLoading && (organisations === undefined || organisations.length === 0) && (
        <p className="text-muted-foreground py-10 text-center">
          The Junea Wallet is not enabled for your organisations. Ask our team to switch it on.
        </p>
      )}

      {organisations !== undefined && organisations.length > 0 && (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          {organisations.map((organisation) => (
            <Link
              key={organisation.id}
              to="/wallets/$organisationId"
              params={{ organisationId: String(organisation.id) }}
              className="focus-visible:ring-ring min-w-0 rounded-xl transition-transform hover:scale-[1.02] focus-visible:ring-2 focus-visible:outline-none"
            >
              <CompanyWalletOrganisationCard
                name={organisation.name}
                membersCount={organisation.users_count}
                className="h-full"
              />
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
